
import { defineComponent, onMounted, ref } from "vue";
import CorporateHeader from "@/components/UserAccounts/CorporateHeader.vue";
import UserAccountModel from "~/models/UserAccountModel";
import UserAccountRepository from "~/repositories/UserAccountRepository";

export default defineComponent({
  name: "UserCorporateLayout",
  components: {
    CorporateHeader
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
    mediumId: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const userAccount = ref(new UserAccountModel());
    const getUserAccount = async () => {
      try {
        const repo = new UserAccountRepository();
        userAccount.value = await repo.show(props.userId);
      } catch (e) {
        console.log(e);
        alert("企業情報の取得に失敗しました。時間が経ってから再度お試しください。");
        window.webpackBugsnagClient.notify(e);
      } finally {
        emit("fetched-user-account");
      }
    };

    const loading = ref(true);
    onMounted(async () => {
      await getUserAccount();
      loading.value = false;
    });

    return {
      loading,
      userAccount
    };
  }
});
